export default __webpack_public_path__ + "static/media/sacha fluted panel.83d5586d.png";